import * as React from 'react';
import { EmbeddedFormViewModelResult } from '../../preconfigured-giving-links/preconfigured-giving-links-generated';

/**
   * Un-minified source code.
   * 
    <div id="pushpay-embedded-giving-fallback"></div>
    <script>
        !(function () {
			window.pushpayEmbeddedConfig = {
				handle: 'SCRIPT_HANDLE',
				wgc: 'SCRIPT_WGC',
			};

			setTimeout(handlePushpayEmbeddedLoadError, 3000);

			function handlePushpayEmbeddedLoadError() {
				if (!window.pushpayEmbeddedFallbackDone) {
					window.pushpayEmbeddedFallbackDone = true;
					var beacon = document.createElement('img');
					beacon.src = 'BEACON_URL?error=EmbeddedWidgetLoadFailed';
					beacon.style.cssText = 'height:1px;width:1px;position:absolute;top:0;left:0;z-index:-1';
					document.body.appendChild(beacon);
				}
			}

			var script = document.createElement('script');
			script.type = 'text/javascript';
			script.async = true;
			script.src = 'SCRIPT_URL';
			script.onerror = handlePushpayEmbeddedLoadError;
			script.onload = function () {
				window.pushpayEmbeddedFallbackDone = true;
			};
			document.getElementsByTagName('head')[0].appendChild(script);
		})();
    </script> 
*/

export const getEmbeddedScript = (info: EmbeddedFormViewModelResult) => `<div id="pushpay-embedded-giving-fallback"></div><script>!function(){window.pushpayEmbeddedConfig={handle:"${info.Handle}",wgc:"${info.WebGivingSignedConfig}"};var e=document.createElement("script");function d(){if(!window.pushpayEmbeddedFallbackDone){window.pushpayEmbeddedFallbackDone=!0;var e=document.createElement("img");e.src="${info.BeaconUrl}?error=EmbeddedWidgetLoadFailed",e.style.cssText="height:1px;width:1px;position:absolute;top:0;left:0;z-index:-1",document.body.appendChild(e)}}e.type="text/javascript",e.async=!0,e.src="${info.ScriptSourceUrl}",setTimeout(d,3e3),e.onerror=d,e.onload=function(){window.pushpayEmbeddedFallbackDone=!0},document.getElementsByTagName("head")[0].appendChild(e)}();</script>`;
